"use strict";

import { closeAllModalDialogs, closeModalDialog, isModalOpen, openModalDialog, switchModalDialog } from "./common";
import { onProductSizeChange } from "../pages/product-details";
import { checkIfSignInSignUpFromCart } from "./auth";

const FREE_DELIVERY_LIMIT = 500;
const DELIVERY_PRICE = 20;
const CART_DELETION_QUEUE_STORAGE_KEY = 'sklCartDeletionQueue';
const CART_DELETION_QUEUE_TIMEOUT = 7000;
let deletionQueueTimer;

export function onAddItemToCart() {
    const thisButton = $(this);
    const productId = thisButton.attr('data-idproduct');
    const productName = thisButton.attr('data-name');
    const productSku = thisButton.attr('data-sku');
    const hasSizes = thisButton.attr('data-has-sizes');
    const productCategory = thisButton.attr('data-category')
     console.log('onAddItemToCart', productId, productName, hasSizes, productId);
    if (hasSizes === 'true' && (!productId || productId === '0')) {
        openSelectProductSizeModal.call(this, productSku, productName, productCategory);
    } else {
        submitAddToCart(productId, productName, productSku);
    }
}

export async function openSelectProductSizeModal(productSku, productName = '', productCategory = '') {
    let res;
    $('body').addClass('loading--product-size');
    try {
        /**
         * @param res: {
         *      id: numberString,
         *      name: string,
         *      qty: numberString,
         *      size_ue: string,
         *  }
         */
        res = await $.ajax({
            type: "GET",
            url: `/ajax/getproductsizes?sku=${productSku}`,
        });

        let parsedResponse;
        try {
            parsedResponse = jQuery.parseJSON(res);
        } catch (e) {
            openCartModificationErrorModal(productName);
            return;
        }

        if (parsedResponse.success === true) {
            const sizeSuffix = productCategory === 'chain' ? 'cm' : '';
            const isRing = productCategory === 'ring';
            const sizes = parsedResponse.products.map((item, index) => {
                if (item.qty <= 0 || !item.size_ue) {
                    return null;
                }
                return `
                        <input type="radio" id="product-size-option-${item.id}" name="product-size" value="${item.id}">
                        <label for="product-size-option-${item.id}">${item.size_ue}${sizeSuffix}</label>
                        <b></b>
                    `;
            });

            const modal = $('#product-size-selector-modal');
            modal.find('.modal__footer [data-open-modal]').toggle(isRing);
            modal.find('.modal__content form')
                .attr('data-sku', productSku)
                .attr('data-product-name', productName)
                .html(sizes.join(''));
            modal.find('.size-not-selected').removeClass('active');
            openModalDialog(undefined, 'product-size-selector-modal');
        } else {
            openCartModificationErrorModal(productName, parsedResponse.message);
        }

        $('body').removeClass('loading--product-size');
        return parsedResponse;
    } catch (error) {
        $('body').removeClass('loading--product-size');
        console.error(error);
        return error;
    }
}

export function addToCartSelectedSize() {
    const modal = $('#product-size-selector-modal');
    const selectedSizeId = modal.find('input:checked').get(0)?.value;
    if (!selectedSizeId) {
        modal.find('.size-not-selected').addClass('active');
        return;
    } else {
        modal.find('.size-not-selected').removeClass('active');
    }
    const productName = modal.find('form').attr('data-product-name');
    const productSku = modal.find('form').attr('data-sku');
    // Available only on Product details page
    const productDetailsSizeSelector = $('.product-details select.product-size__selector').get(0);
    if (productDetailsSizeSelector) {
        productDetailsSizeSelector.value = selectedSizeId;
        onProductSizeChange.call(productDetailsSizeSelector);
    }
    submitAddToCart(selectedSizeId, productName ,productSku);
}

export function openAddItemToCartSuccessModal(productName, successMessage = 'Este adăugat în coș!', img) {
    closeModalDialog(undefined, 'product-size-selector-modal');
    $('#add-to-cart-success-modal .modal__head img').toggle(!!img).attr('src', img).attr('alt', productName);
    $('#add-to-cart-success-modal .modal__content').html(`${productName}<br> ${successMessage}`);
    openModalDialog(undefined, 'add-to-cart-success-modal');
}

export function openCartModificationErrorModal(productName, errorMessage = 'Eroare!', img) {
    closeModalDialog(undefined, 'product-size-selector-modal');
    $('#cart-modification-error-modal .modal__head img').toggle(!!img).attr('src', img).attr('alt', productName);
    $('#cart-modification-error-modal .modal__content').html(`${productName}<br><br> ${errorMessage}`);
    openModalDialog(undefined, 'cart-modification-error-modal');
}

export async function submitAddToCart(productId, productName = '', sku = '') {
    if (typeof fbq !== 'undefined') {
        fbq('track', 'AddToCart', {
            content_name: productName,
            content_category: 'bijuterii',
            content_ids: sku,
            content_type: 'product',
            value: jQuery('#btn-addtocart-'+sku).attr('data-price'),
            product_catalog_id: '847240189544596',
            currency: 'RON'
        });
    }

    let res;
    $('body').addClass('loading--add-to-cart');
    try {
        res = await $.ajax({
            type: "POST",
            url: "/ajax/addtocart",
            data: {
                productId: productId
            }
        });
        const parsedResponse = parseCartModificationResponse(res, productName, {type: 'add'});
        $('body').removeClass('loading--add-to-cart');
        return parsedResponse;
    }  catch (error) {
        $('body').removeClass('loading--add-to-cart');
        console.error(error);
        return error;
    }
}

export async function submitRemoveFromCart(productId, productName) {
    let res;
    $('body').addClass('loading--remove-from-cart');
    try {
        res = await $.ajax({
            type: "POST",
            url: "/ajax/deletecartitem",
            data: {
                id: productId
            }
        });
        const parsedResponse = parseCartModificationResponse(res, productName, {type: 'delete'});
        $('body').removeClass('loading--remove-from-cart');
        return parsedResponse;
    } catch (error) {
        $('body').removeClass('loading--remove-from-cart');
        console.error(error);
        return error;
    }
}

/**
 *
 * @param productIds - number for single deletion or array of numbers for multiple deletion
 * @param productName - string or array of strings for multiple deletion
 * @returns {Promise<*>}
 */
export async function submitRemoveMultipleFromCart(productIds, productNames) {
    console.log('>>> submitRemoveMultipleFromCart', productIds, productNames);
    if (!Array.isArray(productIds)) {
        productIds  = [productIds];
    }
    let res;
    $('body').addClass('loading--remove-from-cart');
    try {
        res = await $.ajax({
            type: "POST",
            url: "/ajax/deletecartitems",
            data: {
                id: productIds
            }
        });
        const parsedResponse = parseCartModificationResponse(res, productNames, {type: 'delete'});
        $('body').removeClass('loading--remove-from-cart');
        return parsedResponse;
    } catch (error) {
        $('body').removeClass('loading--remove-from-cart');
        console.error(error);
        return error;
    }
}

/**
 *
 * @param productId: string
 * @param productName: string
 * @param actionType: number - 1 is for plus, 2 is for minus, 3 is for exact qty
 * @param qty: number - provide only if actionType is 3
 */
export async function submitChangeQty(productId, productName, actionType, qty) {
    const types = {
        1: 'plus',
        2: 'minus',
        3: 'setQty',
    };
    const data = {
        id: productId,
        changeType: actionType
    };
    if (actionType === 3) {
        data.qty = qty;
    }
    let res;
    $('body').addClass('loading--change-cart-qty');
    try {
        res = await $.ajax({
            type: "POST",
            url: "/ajax/updateqtycart",
            data,
        });
        const parsedResponse = parseCartModificationResponse(res, productName, {type: types[actionType]});
        $('body').removeClass('loading--change-cart-qty');
        return parsedResponse;
    } catch (error) {
        $('body').removeClass('loading--change-cart-qty');
        console.error(error);
        return error;
    }
}

/**
 *
 * @param productId: string
 * @param newProductSizeId: string
 * @param productName: string
 */
export async function submitChangeSize(productId, newProductSizeId, productName) {
    const data = {
        id: productId,
        newSizeId: newProductSizeId,
    };
    let res;
    $('body').addClass('loading--change-cart-item-size');
    try {
        res = await $.ajax({
            type: "POST",
            url: "/ajax/changecartitemsize",
            data,
        });
        const parsedResponse = parseCartModificationResponse(res, productName, {type: 'changeSize'});
        $('body').removeClass('loading--change-cart-item-size');
        return parsedResponse;
    } catch (error) {
        $('body').removeClass('loading--change-cart-item-size');
        console.error(error);
        return error;
    }
}

/**
 * Simply fetch current cart data.
 * Usefull to use after appling promo code
 */
export async function getCartItems() {
    let res;
    $('body').addClass('loading--refresh-cart-items');
    try {
        res = await $.ajax({
            type: "GET",
            url: "/ajax/getcartitems",
        });
        let parsedResponse;
        try {
            parsedResponse = jQuery.parseJSON(res);
        } catch (e) {
            $('body').removeClass('loading--refresh-cart-items');
            return;
        }
        rebuildCartContent(parsedResponse);
        rebuildCheckoutPageCartContent(parsedResponse);
        $('body').removeClass('loading--refresh-cart-items');
        return parsedResponse;
    } catch (error) {
        $('body').removeClass('loading--refresh-cart-items');
        console.error(error);
        return error;
    }
}

/**
 * Parse BE response and do some logic
 * @param response
 * @param productName: string|string[]
 * @param other: {
 *      type: 'add', 'delete', 'plus', 'minus', 'setQty', 'changeSize', 'refresh'
 * }
 */
export function parseCartModificationResponse(response, productName, {type}) {
    if (Array.isArray(productName)) {
        productName = productName.join(', ');
        console.log('>>> parseCartModificationResponse joined names', productName);
    }
    let parsedResponse;
    try {
        parsedResponse = jQuery.parseJSON(response);
    } catch (e) {
        openCartModificationErrorModal(productName);
        return;
    }

    let img, name;
    if (parsedResponse?.dataInsert) {
        img = parsedResponse?.dataInsert.img;
        name = parsedResponse?.dataInsert.name;
    }

    if (parsedResponse.success === true) {
        rebuildCartContent(parsedResponse);
        rebuildCheckoutPageCartContent(parsedResponse);

        if (type === 'add') {
            openAddItemToCartSuccessModal(name || productName, undefined, img);
        }

        if (type === 'delete' && !parsedResponse.dataAll.length && isModalOpen('cart-modal')) {
            switchModalDialog(undefined, 'cart-empty-modal');
        }
    } else {
        openCartModificationErrorModal(name || productName || parsedResponse.name, parsedResponse.message, img || parsedResponse.img);
    }

    return parsedResponse;
}

/**
 * Sync current cart state with the latest response from BE:
 * @param cartData: {
 *         success: booleanString,
 *         cartQty: numberString,
 *         cartTotal: number,
 *         cartAvailableTotal: number,
 *         deliveryPrice: number,
 *         dataInsert => 01String,
 *         dataUpdate => 01String,
 *         dataAll: {
 *              id: numberString,
 *              idproduct: numberString,
 *              qty: numberString,
 *              qtyAvailable: numberString,
 *              name: string,
 *              img: string,
 *              price: numberString,
 *              discount: numberString,
 *              discountLabel: string,
 *              priceDiscount: number,
 *              size: string,
 *              sizesAvailable: [
 *                  {
 *                      id: numberString,
 *                      name: string,
 *                      qty: numberString,
 *                      size_ue: string,
 *                  }
 *              ]
 *         }
 *     }
 */
export function rebuildCartContent(cartData) {
    if (!cartData) {
        return;
    }
    const cart = jQuery('#cart-modal .cart-products');
    cart.empty();
    cartData.dataAll.forEach((item) => {
        const cartItemInfoContainer = item.qtyAvailable > 0 ? `
            <div class="cart-product__name-container">
                <a class="cart-product__name" href="/linkto/product/${item.idproduct}">${item.name}</a>
    
                ${item.qty > 1 ? `<div class="cart-product__qty">Canitate: ${item.qty}</div>` : ``}
    
                ${item.size !== 'null' && Array.isArray(item.sizesAvailable) && item.sizesAvailable.length ? `
                    <div class="cart-product__size">
                        Mărime: 
                        <span>${item.size}</span>
                        <select>
                        ${
                            item.sizesAvailable
                                .filter((size) => {
                                    return size.qty > 0;
                                })
                                .map((size) => {
                                    return `<option value="${size.id}" ${item.size === size.size_ue ? 'selected' : ''} ${size.qty < 1 ? 'disabled' : ''} data-qty-available="${item.qty}">${size.size_ue}</option>`;
                                })
                                .join('')
                        }
                        </select>
                    </div>
                ` : ``}
            </div>
    
            <div class="cart-product__price-container">
                <div class="cart-product__qty-selector">
                    <select>
                        <option value="0">0</option>
                        ${
                            Array(Math.min(item.qtyAvailable, 10)).fill().map((_, i) => {
                                const n = i + 1;
                                return `<option value="${n}" ${+item.qty === n ? 'selected' : ''}>${n}</option>`;
                            }).join(``)
                        }
                    </select>
                </div>
                
                <div class="cart-product__price">${(+(item.discount) ? +item.priceDiscount : +item.price).toFixed(2).replace('.00', '')} RON</div>
    
                ${+(item.discount) ? `
                    <div class="cart-product__sale">
                        -${item.discount}% ${item.discountLabel}
                    </div>
                ` : ''}
                   
                ${+(item.discount) ? `
                    <del class="cart-product__old-price">${(+item.price).toFixed(2).replace('.00', '')} RON</del>
                ` : ``}
            </div>
        ` : `
            <strong>Produsul nu mai este în stoc</strong>
            <button class="cart-product__confirm-out-of-stock-deletion button button--small button--outline button--transparent">
                Ok
            </button>
        `;

        const cartItem = `
            <li class="cart-product ${item.qty < 1 ? `cart-product--sold-out`:``}" data-idproduct="${item.idproduct}"  data-id="${item.id}" data-qty-available="${item.qtyAvailable}" data-qty="${item.qty}" data-size="${item.size ?? ''}">
                <div class="cart-product__image-container">
                    <img src="${item.img}" alt="${item.name}" loading="lazy">
                    <i class="skl-icon-close"></i>
                    <a href="/linkto/product/${item.idproduct}"></a>
                </div>
                <div class="cart-product__info-container">
                    ${cartItemInfoContainer}
                </div>
                <button class="cart-product__mobile-menu button button--square button--icon button--small" >
                    <i class="skl-icon-vertical-dots"></i>
                </button>
            </li>`;
        cart.append(cartItem);
    });

    $('.header__actions .cart .cart__badge').text(cartData.cartQty);
    $('#cart-modal .total-price-container .delivery-price').next('dd').html(`${cartData.deliveryPrice} RON`);
   
    
    if(cartData.cartAvailableTotal == 0){
        $('#cart-modal .modal__footer .button--success').attr('disabled', 'disabled');
        $('#cart-modal .total-price-container .total-price').next('dd')   .html(`${(cartData.cartAvailableTotal).toFixed(2).replace('.00', '')} RON`);
    }else{
        $('#cart-modal .total-price-container .total-price').next('dd')   .html(`${(cartData.cartAvailableTotal + cartData.deliveryPrice).toFixed(2).replace('.00', '')} RON`);
        $('#cart-modal .modal__footer .button--success').removeAttr('disabled');
    }

    $('#cart-modal .cart-delivery-cost-wrapper .cart-delivery-cost').removeClass('active');
    if (cartData.deliveryPrice > 0) {
        $('#cart-modal .cart-delivery-cost-wrapper .cart-delivery-cost--paid').addClass('active');
        $('#cart-modal .cart-delivery-cost-wrapper .cart-delivery-cost--paid .delivery-price').html(FREE_DELIVERY_LIMIT - cartData.cartTotal);
    } else {
        $('#cart-modal .cart-delivery-cost-wrapper .cart-delivery-cost--free').addClass('active');
    }
    // $('.mbtotalQtyLabel').html(cartData.cartQty);

    document.dispatchEvent(new CustomEvent("sklCartUpdated", {
        detail: cartData
    }));
}

/**
 * Sync current checkout page cart state with the latest response from BE:
 * @param cartData: {
 *         success: booleanString,
 *         cartQty: numberString,
 *         cartTotal: number,
 *         cartAvailableTotal: number,
 *         deliveryPrice: number,
 *         dataInsert => 01String,
 *         dataUpdate => 01String,
 *         dataAll: {
 *              id: numberString,
 *              idproduct: numberString,
 *              qty: numberString,
 *              qtyAvailable: numberString,
 *              name: string,
 *              img: string,
 *              price: numberString,
 *              discount: numberString,
 *              discountLabel: string,
 *              priceDiscount: number,
 *              size: string,
 *              sizesAvailable: [
 *                  {
 *                      id: numberString,
 *                      name: string,
 *                      qty: numberString,
 *                      size_ue: string,
 *                  }
 *              ]
 *         }
 *     }
 */
export function rebuildCheckoutPageCartContent(cartData) {
    if (!cartData || !$('.checkout-page').length) {
        return;
    }
    if (cartData.dataAll.length < 1) {
        window.location.href = '/';
    }
    const cart = $('.checkout-page .cart-details__cart-products');
    const cartContent = cartData.dataAll.map((item) => {
        if (item.qtyAvailable < 1) {
            return ``;
        }

        return `
        <li class="cart-product ${item.qty < 1 ? `cart-product--sold-out`:``}" data-idproduct="${item.idproduct}"  data-id="${item.id}" data-qty-available="${item.qtyAvailable}" data-qty="${item.qty}" data-size="${item.size ?? ''}">
            <div class="cart-product__image">
                <img src="${item.img}" alt="${item.name}" loading="lazy">
            </div>

            <div class="cart-product__name">
                <a href="/linkto/product/${item.idproduct}" title="${item.name}">
                    ${item.name}                             
                </a>
            </div>
  
            <div class="cart-product__qty">
                Canitate: 
                <span>${item.qty}</span>
            </div>

            ${item.size !== 'null' && Array.isArray(item.sizesAvailable) && item.sizesAvailable.length ? `
            <div class="cart-product__size">
                Mărime: 
                <span>${item.size}</span>
            </div>
            ` : ``}
            
            <div class="cart-product__price">${(+(item.discount) ? +item.priceDiscount : +item.price).toFixed(2).replace('.00', '')} RON</div>

            ${+(item.discount) ? `
            <div class="cart-product__sale">
                -${item.discount}%
            </div>
            ` : ''}
        
            ${+(item.discount) ? `
            <del class="cart-product__old-price">${(+item.price).toFixed(2).replace('.00', '')} RON</del>
            ` : ``}
        </li>
        `;
    });
    cart.html(cartContent.join(`\n`));

    $('.checkout-page .cart-details__items-count').html(`${cartData.cartQty}`);
    $('.checkout-page .order-summary__delivery-price').next('dd')
        .html(`<span>${cartData.deliveryPrice}</span>&nbsp;RON`);
    $('.checkout-page .order-summary__items-price').next('dd')
        .html(`<span>${cartData.cartAvailableTotal.toFixed(2).replace('.00', '')}</span>&nbsp;RON`);
    $('.checkout-page .order-summary__total-price').next('dd')
        .html(`<span>${parseFloat((cartData.cartAvailableTotal + cartData.deliveryPrice).toFixed(2))}</span>&nbsp;RON`)
        .attr('data-original-price', parseFloat((cartData.cartAvailableTotal + cartData.deliveryPrice).toFixed(2).replace('.00', '')));

    document.dispatchEvent(new CustomEvent("sklCheckoutPageCartUpdated", {
        detail: cartData
    }));
}

/**
 * if no event provied - last open menu will be reopened
 * @param event
 */
export function cartItemMobileMenuOpen(event) {
    $('.cart-item-menu').find('.cart-item-menu__size, .cart-item-menu__qty, .cart-item-menu__notify-product-availability').remove();
    const cartItem = event ? $(this).closest('.cart-product').addClass('active-mobile-menu') : $('.cart-modal .cart-product.active-mobile-menu');
    if (!cartItem.length) {
        $('.cart-item-menu').removeClass('active');
        console.warn('No cartItem available for opening mobile menu');
        return;
    }
    const qty = +cartItem.attr('data-qty');
    const qtyAvailable = +cartItem.attr('data-qty-available');
    const size = cartItem.attr('data-size');

    $('.cart-item-menu')
        .addClass('active')
        .attr('data-id', cartItem.attr('data-id'))
        .attr('data-name', cartItem.find('.cart-product__name').text())
        .attr('data-qty-available', qtyAvailable)
        .attr('data-size', size);


    if (qtyAvailable > 0) {
        $('.cart-item-menu ul').prepend(`<li class="cart-item-menu__qty"></li>`);
        if (qty === 1 && qtyAvailable === 1) {
            $('.cart-item-menu ul .cart-item-menu__qty')
                .attr('data-selected-value', null)
                .addClass('cart-item-menu__qty--last')
                .html(`
                    Canitate:&nbsp; <span>Ultimul in coș</span>
                `);
        } else {
            const qtyOptions = Array(Math.min(qtyAvailable, 10)).fill().map((_, i) => {
                const n = i + 1;
                return `<option value="${n}" ${qty === n ? 'selected' : ''}>Canitate: ${n}</option>`;
            }).join(``);
            $('.cart-item-menu ul .cart-item-menu__qty')
                .attr('data-selected-value', `Canitate: ${qty}`)
                .removeClass('cart-item-menu__qty--last')
                .html(`
                <select>
                    ${qtyOptions}
                </select>
            `);
        }
    } else {
        $('.cart-item-menu ul').prepend(`
            <li class="cart-item-menu__notify-product-availability">
                <button class="button button--small button--outline button--transparent">
                    Anunta-ma
                </button>
            </li>
        `);
    }

    if (size) {
        const sizeOptionsParams = cartItem.find('.cart-product__size select option').toArray().map((item) => {
            return {
                id: $(item).attr('value'),
                size: $(item).text(),
                selected: !!$(item).attr('selected'),
                qtyAvailable: $(item).attr('data-qty-available'),
            };
        });

        const sizeOptions = sizeOptionsParams.map((sizeOption) => {
            return `<option value="${sizeOption.id}" ${sizeOption.selected ? 'selected' : ''} data-qty-available="${sizeOption.qtyAvailable}">Mărime: ${sizeOption.size}</option>`;
        }).join('');

        const selectedSize = sizeOptionsParams.find(sizeOption => sizeOption.selected);

        $('.cart-item-menu ul')
            .prepend(`
                <li class="cart-item-menu__size" data-selected-value="Mărime: ${selectedSize.size}">
                    <select>
                        ${sizeOptions}
                    </select>
                </li>
            `);
    } else {
        cartItem.find('.cart-product__size').remove();
    }
}

export function cartItemMobileMenuClose(event) {
    if (!event || (event && event.target === this)) {
        $('.cart-item-menu').removeClass('active');
        $('.cart-modal .cart-product').removeClass('active-mobile-menu');
    }
}

export function onDeleteItemFromModalCart() {
    const id = $(this).closest('.cart-product').attr('data-id');
    const name = $(this).closest('.cart-product').find('.cart-product__name').text();
    addItemDeletionToQueue(id, name);
}

export function onDeleteItemFromModalCartMobileMenu() {
    const id = $(this).closest('.cart-item-menu').attr('data-id');
    const name = $(this).closest('.cart-item-menu').attr('data-name');
    addItemDeletionToQueue(id, name);
    cartItemMobileMenuClose();
}

export function onDeleteSoldOutItemFromModalCart() {
    const id = $(this).closest('.cart-product').attr('data-id');
    const name = 'Produsul care nu mai este în stoc';
    submitRemoveFromCart(id, name);
}

export function addItemDeletionToQueue(id, name) {
    const cartItem = $(`.modal.cart-modal .cart-product[data-id="${id}"]`);
    if ( cartItem.find('.cart-product__deletion-container').length) {
        return;
    }

    let queue = JSON.parse(localStorage.getItem(CART_DELETION_QUEUE_STORAGE_KEY) ?? '[]');
    queue.push({id, name});
    localStorage.setItem(CART_DELETION_QUEUE_STORAGE_KEY, JSON.stringify(queue));

    cartItem
        .addClass('cart-product--pending-deletion')
        .append(`
            <div class="cart-product__deletion-container">
                <strong>Produsul vor fi scos din cosul de cumpărături.</strong>
                <button class="button button--link">Adaugă-l inapoi</button>
            </div>
        `);

    setupDeletionQueueTimer();

    cartItem.find(`.cart-product__deletion-container button`).on('click', () => {
        queue = JSON.parse(localStorage.getItem(CART_DELETION_QUEUE_STORAGE_KEY) ?? '[]');
        queue = queue.filter(i => i.id !== id);
        localStorage.setItem(CART_DELETION_QUEUE_STORAGE_KEY, JSON.stringify(queue));
        setupDeletionQueueTimer();
        cartItem
            .removeClass('cart-product--pending-deletion')
            .find('.cart-product__deletion-container')
            .remove();
        const originalQty = cartItem.attr('data-qty');
        cartItem.find('.cart-product__qty-selector select').val(originalQty);
    })
}

export function setupDeletionQueueTimer() {

    if (deletionQueueTimer) {
        clearTimeout(deletionQueueTimer);
    }

    let queue = JSON.parse(localStorage.getItem(CART_DELETION_QUEUE_STORAGE_KEY) ?? '[]');
    if (!queue.length) {
        return;
    }
    deletionQueueTimer = setTimeout(async () => {
        await submitRemoveMultipleFromCart(queue.map(i => i.id), queue.map(i => i.name));
        localStorage.setItem(CART_DELETION_QUEUE_STORAGE_KEY, JSON.stringify([]));
    }, CART_DELETION_QUEUE_TIMEOUT);
}

export async function cleanDeletionQueue() {
    let queue = JSON.parse(localStorage.getItem(CART_DELETION_QUEUE_STORAGE_KEY) ?? '[]');
    if (!queue.length) {
        return;
    }
    if (deletionQueueTimer) {
        clearTimeout(deletionQueueTimer);
    }
    await submitRemoveMultipleFromCart(queue.map(i => i.id), queue.map(i => i.name));
    localStorage.setItem(CART_DELETION_QUEUE_STORAGE_KEY, JSON.stringify([]));
}

export async function onChangeSizeFromModalCartMobileMenu() {
    const id = $(this).closest('.cart-item-menu').attr('data-id');
    const name = $(this).closest('.cart-item-menu').attr('data-name');
    const value = $(this).find(':selected').get(0).value;
    const changeSizeResponse = await submitChangeSize(id, value, name);
    if (changeSizeResponse.success === false) {
        const originalSizeId = cartProduct.attr('data-idproduct');
        cartProduct.find('.cart-product__size select').val(originalSizeId);
    }
    cartItemMobileMenuOpen();
}

export async function onChangeSizeFromModalCartDesktopItem() {
    const cartProduct = $(this).closest('.cart-product');
    const id = cartProduct.attr('data-id');
    const name = cartProduct.attr('data-name');
    const value = $(this).find(':selected').get(0).value;
    const changeSizeResponse = await submitChangeSize(id, value, name);
    if (changeSizeResponse.success === false) {
        const originalSizeId = cartProduct.attr('data-idproduct');
        cartProduct.find('.cart-product__size select').val(originalSizeId);
    }
}

export async function onChangeQtyFromModalCartMobileMenu() {
    const id = $(this).closest('.cart-item-menu').attr('data-id');
    const name = $(this).closest('.cart-item-menu').attr('data-name');
    const value = $(this).find(':selected').get(0).value;
    if (+value === 0) {
       await addItemDeletionToQueue(id, name);
    } else {
       await submitChangeQty(id, name, 3, value);
    }
    cartItemMobileMenuClose();
}

export function onChangeQtyFromModalCartDesktopItem() {
    const id = $(this).closest('.cart-product').attr('data-id');
    const name = $(this).closest('.cart-product').attr('data-name');
    const value = $(this).find(':selected').get(0).value;
    if (+value === 0) {
        addItemDeletionToQueue(id, name);
    } else {
        submitChangeQty(id, name, 3, value);
    }
}

export default function init() {
    cleanDeletionQueue();

    $('body').on('click', '.product-card__add-to-cart, .add-to-cart', onAddItemToCart);
    $('#product-size-selector-modal .add-to-cart-selected-size').on('click', addToCartSelectedSize);
    $('#add-to-cart-success-modal, #cart-modification-error-modal').on('click', '.continue-shopping', closeModalDialog);

    $('.cart-modal')
        .on('click', '.cart-product__image-container i', onDeleteItemFromModalCart)
        .on('click', '.cart-product__mobile-menu', cartItemMobileMenuOpen)
        .on('click', '.cart-item-menu', cartItemMobileMenuClose)
        .on('change', '.cart-item-menu__size select', onChangeSizeFromModalCartMobileMenu)
        .on('change', '.cart-item-menu__qty select', onChangeQtyFromModalCartMobileMenu)
        .on('click', '.cart-item-menu__remove button', onDeleteItemFromModalCartMobileMenu)
        .on('click', '.cart-product__confirm-out-of-stock-deletion', onDeleteSoldOutItemFromModalCart)
        .on('change', '.cart-product__size select', onChangeSizeFromModalCartDesktopItem)
        .on('change', '.cart-product__qty-selector select', onChangeQtyFromModalCartDesktopItem);

    $('.header__actions .cart button').on('click', function(e){
        const count = $(this).find('.cart__badge').text().trim();
        if (count && +count === 0) {
            openModalDialog(e, 'cart-empty-modal');
        } else {
            openModalDialog(e, 'cart-modal');
        }
    });

    document.addEventListener("modalDialog", function(event) {
        switch(event.detail?.id){
            case 'cart-modal':
                cartItemMobileMenuClose();

                if (event.detail.eventType === "close" && $('.checkout-page').length) {
                    cleanDeletionQueue();
                }
                break;
        }
    });
}